module.exports = __webpack_public_path__ + "assets/4f4f8da12f5c87003416e2d909b3de2b.png";